import { SmallCalendar } from './types'
import { useRef } from 'react'

export function useSmallCalendar() {
  return useRef<SmallCalendar>(null)
}
